import React, { useState } from 'react';
import { Card, Icon, Button } from 'antd';


type Props = {
    isRunningBatchAnalysis?: boolean;
    onViewSeoTestDetails: (testKey: string) => void;
    passedChecks: {
        test_key: string;
        title: string;
        description: string;
        relevance: number;
        message: string;
    }[];
};

export default function SiteWidePassedChecks({ passedChecks, onViewSeoTestDetails }: Props) {
    const [isExpanded, setIsExpanded] = useState(false);
    const [expandLabel, setExpandLabel] = useState(`Show all (${passedChecks.length})`);
    const handleExpand = () => {
        setIsExpanded(!isExpanded);
        setExpandLabel(isExpanded ? `Show all (${passedChecks.length})` : "Show less");
    }
    const visiblePassedChecks = isExpanded ? passedChecks : passedChecks.slice(0, 3);
    return (
        <Card className="passed-checks" type="inner" title="Passed checks" actions={[<span className="label" onClick={handleExpand}>{expandLabel}</span>]}>
            {visiblePassedChecks.map((check) => (
                <div className="passed-check-item" key={check.test_key}>
                    <Icon type={"check-circle"} theme="filled" className="status-icon" />
                    <div className="item-description">
                        <div className="title">{check.title}</div>
                        <div className="message" dangerouslySetInnerHTML={{ __html: check.message }} />
                    </div>
                    <Button
                        className="details-button website"
                        size="small"
                        onClick={(() => onViewSeoTestDetails(check.test_key))}
                    >
                        <Icon type="eye" /> View Details
                    </Button>
                </div>
            ))}
        </Card>
    );
}
